import React from 'react';

/**
 * 리뷰 완료 카드 — OKDC ReviewCompleteWindow.xaml (v2.1.50) 픽셀 1:1 포팅.
 *
 * Props:
 *   - tableName: string ("101")
 *   - serviceMenu: string ("사이다 1캔")
 *   - onClose?: () => void
 */
const ReviewCompleteCard = ({ tableName = '101', serviceMenu = '사이다 1캔', hasPhoto = false, channel = 'naver', onClose }) => {
  const isKakao = channel === 'kakao';
  const accent = isKakao ? '#FDCD28' : '#03C75A';
  return (
    <div className="rc-wrap" onClick={onClose}>
      <div className="rc-card">
        {/* 체크 배지 + 헤드라인 */}
        <div className="rc-head">
          <div className="rc-check" aria-hidden style={{ background: accent }}>
            {/* iconify tabler:check — Viewbox Margin="-4,-4" 효과: SVG translate(-4,-4) */}
            <svg className="rc-check-svg" viewBox="0 0 24 24" width="24" height="24">
              <path
                d="M5,12 L10,17 L20,7"
                stroke={isKakao ? '#191919' : '#FFFFFF'}
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div className="rc-headline">
            <div className="rc-label">
              {isKakao ? (
                <span className="rc-label-text" style={{ color: '#FDCD28' }}>카카오 리뷰</span>
              ) : (
                <>
                  <img className="rc-logo" src="/naver_logo_green.png" alt="NAVER" />
                  <span className="rc-label-text" style={{ color: '#2BD47E' }}>리뷰</span>
                </>
              )}
            </div>
            {/* PC ReviewCompleteWindow 와 동일 — 사진 포함 시 헤드라인 텍스트 변경 */}
            <div className="rc-done">{hasPhoto ? '사진 포함 + 리뷰 작성 완료!' : '리뷰 작성 완료!'}</div>
          </div>
        </div>

        {/* 테이블 번호 — XAML Run + " 테이블" 공백 매핑: margin-left 4px */}
        <div className="rc-table">
          <span className="rc-num">{tableName}</span>
          <span className="rc-suffix">테이블</span>
        </div>

        {/* 서비스 메뉴 박스 */}
        <div className="rc-service" style={{ background: accent }}>
          {serviceMenu} 을(를) 제공해주세요!
        </div>
      </div>

      <style jsx>{`
        @keyframes rcEnter {
          0%   { opacity: 0; transform: translateY(22px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        .rc-wrap {
          padding: 0 34px;
          box-sizing: border-box;
          cursor: pointer;
          pointer-events: auto;
        }
        .rc-card {
          width: 340px;
          padding: 20px 22px;
          background: #232323;
          border-radius: 18px;
          /* CardShadow: blur 34, depth 12, opacity .35 */
          box-shadow: 0 12px 34px rgba(0,0,0,.35);
          color: #fff;
          font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
          animation: rcEnter 340ms cubic-bezier(.2,.8,.4,1) both;
        }
        .rc-head {
          display: flex;
          align-items: center;
        }
        .rc-check {
          width: 46px;
          height: 46px;
          border-radius: 23px;
          background: #03C75A;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          overflow: hidden;
        }
        /* 체크마크는 원 중앙 정렬 (기존 translate(-4,-4) 는 좌상단으로 치우쳐 제거) */
        .rc-check-svg {
          display: block;
        }
        .rc-headline {
          margin-left: 13px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .rc-label {
          display: flex;
          align-items: center;
          line-height: 1;
        }
        .rc-logo {
          height: 11px;
          margin-right: 3px;
        }
        /* XAML "리뷰" Margin="0,1,0,0" — top 1px */
        .rc-label-text {
          font-size: 15px;
          font-weight: 600;
          color: #2BD47E;
          margin-top: 1px;
        }
        .rc-done {
          font-size: 19px;
          font-weight: 800;
          color: #FFFFFF;
        }
        /* XAML TextBlock Margin="0,14,0,0" */
        .rc-table {
          margin-top: 14px;
          display: flex;
          align-items: baseline;
        }
        .rc-num {
          font-size: 29px;
          font-weight: 800;
          color: #FFFFFF;
          line-height: 1;
        }
        /* XAML Run Text=" 테이블" 의 공백 1칸 매핑 */
        .rc-suffix {
          font-size: 13px;
          font-weight: 600;
          color: #9A9A9A;
          margin-left: 4px;
        }
        /* XAML Border Margin="0,13,0,0" Padding="14,12,14,10" CornerRadius="10" */
        .rc-service {
          margin-top: 13px;
          padding: 12px 14px 10px;
          background: #03C75A;
          border-radius: 10px;
          font-size: 17px;
          font-weight: 800;
          color: #191919;
          line-height: 22px;
          word-break: keep-all;
        }
      `}</style>
    </div>
  );
};

export default ReviewCompleteCard;
